import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

export const reviews = [
	{
		id: 1,
		text: "Anna's expertise in balayage is exceptional! As someone who's tried many colorists, I can say she truly understands how to create that perfect, natural-looking gradient. Her attention to detail and understanding of different hair textures is amazing.",
		author: "Natalia K.",
		rating: 5,
		service: "Balayage"
	},
	{
		id: 2,
		text: "Finally found a stylist who understands Asian hair! Anna's color correction work is incredible. She fixed my previous bleaching damage and gave me exactly the ash-blonde tone I wanted. Her knowledge of hair chemistry is impressive.",
		author: "Olena V.",
		rating: 5,
		service: "Color Correction"
	},
	{
		id: 3,
		text: "The best keratin treatment I've ever had! Anna explained everything about the process and gave great maintenance tips. My hair has never been so manageable and healthy-looking.",
		author: "Katerina M.",
		rating: 5,
		service: "Keratin Treatment"
	},
	{
		id: 4,
		text: "Anna is not just a hairstylist, she's an artist who understands different hair types and textures. Her precision in cutting and styling is remarkable. Always leave feeling confident and beautiful!",
		author: "Tatiana S.",
		rating: 5,
		service: "Women's Haircut"
	},
	{
		id: 5,
		text: "Such a talented colorist! Anna created the perfect blonde highlights for my dark hair, maintaining its health and giving me exactly the look I wanted. Her salon is so welcoming and professional.",
		author: "Marina P.",
		rating: 5,
		service: "Highlights"
	},
	{
		id: 6,
		text: "Amazing experience! Anna's expertise with both color and cuts is exceptional. She took time to understand what I wanted and suggested the perfect style for my face shape. Definitely found my forever stylist!",
		author: "Svetlana D.",
		rating: 5,
		service: "Color & Cut"
	},
	{
		id: 7,
		text: "I love how Anna takes the time to understand exactly what you want. She gave me the most beautiful balayage I've ever had, perfectly blended and natural-looking. Her attention to detail is outstanding!",
		author: "Irina M.",
		rating: 5,
		service: "Balayage"
	},
	{
		id: 8,
		text: "Best hair transformation ever! Anna's color correction skills are amazing. She fixed my brassy highlights and created the most beautiful, natural-looking blonde. Plus, she gave great advice for maintaining the color.",
		author: "Oksana P.",
		rating: 5,
		service: "Color Correction"
	},
	{
		id: 9,
		text: "Anna is truly gifted with hair! She gave me the perfect haircut that frames my face beautifully and is so easy to style at home. Her technique and precision are remarkable.",
		author: "Yulia R.",
		rating: 5,
		service: "Women's Haircut"
	}
];

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
);

reportWebVitals();
